import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Component } from 'react';

import '../../../styles/resize.scss';

export class ResizeIcon extends Component {
    state = {};

    render() {
      return (
        <ExpandMoreIcon
          className="resize-icon"
          {...this.props}
        />
      );
    }
}
